import { motion } from 'framer-motion'
import React, { useContext } from 'react'
import { IoDocumentAttachSharp } from 'react-icons/io5'
import { ColumnsTable } from 'safe'
import Table from '../../../components/Display/Table'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import { formatPipe, getDenomination, getItemType, transformDate } from '../../../utils/utils'
import { ThemeContext } from '../../../context/ThemeContext'


const hasWithholdingData = (withholding: any) => {
  if (!withholding) return false
  return Object.values(withholding).some(value => value !== null)
}

const WatchPurchase: React.FC<IWatchPurchase> = ({ purchase }) => {

  const { theme } = useContext(ThemeContext)

  const itemsColumns: ColumnsTable[] = [
    {
      title: 'Tipo',
      dataIndex: 'item.type',
      key: 'item.type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {getItemType(record.type).value}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount',
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper
      //     subElement="paragraph"
      //     subElementStyle={`${record?.barcode ? '' : 'text-gray-600'}`}
      //   >
      //     {record?.barcode ? record?.barcode : 'N/A'}
      //   </ColumnItemWrapper>
      // ),
    },
    // {
    //   title: 'Excento',
    //   dataIndex: 'exempt',
    //   key: 'exempt',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{record?.exempt ? 'Sí' : 'No'}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'Costo',
      dataIndex: 'cost',
      key: 'cost',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          { `${getDenomination(record?.currency?.id)} ${formatPipe(record?.cost)}` }
        </ColumnItemWrapper>
      ),
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper>
      //     <p
      //       className={`${
      //         !(record?.cost.length > 0) ? 'text-warning' : 'text-success'
      //       }`}
      //     >
      //       {record?.cost.length > 0 ? (
      //         'Bs ' + record?.cost[0]?.amount
      //       ) : (
      //         <span>
      //           Sin Precio <FiAlertTriangle className="text-warning inline" />
      //         </span>
      //       )}
      //     </p>
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Recibido',
      dataIndex: 'received',
      key: 'received',
    },
  ]

  const paymentsColumns: ColumnsTable[] = [
    {
      title: 'Cuenta',
      dataIndex: 'account.code',
      key: 'account.code',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          { `${getDenomination(record?.currency?.id)} ${formatPipe(record?.amount)}` }
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Fecha de egreso',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      )
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    }
  ]


  return (
    <>
      <h2 className="ml-5 mb-5 text-primary dark:text-white font-bold text-3xl">
        Ver compra
      </h2>
      <div
        className="grid grid-cols-12 auto-rows-fr gap-4"
        style={{ height: '100%' }}
      >
        <div
          className="col-span-6"
          style={{ height: '100%', overflow: 'auto' }}
        >
          <Table
            columns={itemsColumns}
            data={purchase?.items}
            showPagination={false}
          />
        </div>

        <div className="col-span-6">
          <div
            className="grid grid-cols-12 grid-rows-12 auto-rows-fr gap-4"
            style={{ height: '100%' }}
          >
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-span-4 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2 className="text-xs font-medium mb-1" style={{ color: '#006AEA' }}>
                Monto total
              </h2>
              <h2 className="text-xs font-medium mb-1">Descuento: {formatPipe(purchase?.discount)}</h2>
              <h2 className="text-xs font-medium mb-1">IVA (16%): {formatPipe(purchase?.iva)}</h2>
              <h2 className="text-xs font-medium mb-1">IGFT: {formatPipe(purchase?.igtf)}</h2>
              <h2 className="text-xs font-medium mb-1">Monto total: {formatPipe(purchase?.cost)}</h2>
              <h2 className="text-xs font-medium mb-1">Monto total en usd: {formatPipe(purchase?.usdCost)}</h2>
            </div>
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-span-4 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <div className="flex flex-row mb-1">
                <IoDocumentAttachSharp className="text-primary mb-2 mr-3" />
                <h2
                  className="text-xs font-medium"
                  style={{ color: '#006AEA' }}
                >
                  Datos del proveedor
                </h2>
              </div>

              <h2 className="text-xs font-medium mb-1">
                Razón social: {purchase?.provider?.businessName}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                Nombre comercial: Las 3 Marias
              </h2> */}
              <h2 className="text-xs font-medium mb-1">Documento: {purchase?.provider?.documentType}-{purchase?.provider?.document}</h2>
              {/* <h2 className="text-xs font-medium mb-1">
                Dirección Fiscal: Av Bella vista calle 80{' '}
              </h2> */}
            </div>

            <div
              className="dark:bg-black bg-primary-1500 col-span-6 row-span-3 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2 className="text-xs font-medium mb-1" style={{ color: '#006AEA' }}>
                Devoluciones
              </h2>

              {/* <h2 className="text-xs font-medium mb-1">
                Almacén: {purchase?.warehouse?.name}
              </h2> */}

              {/* <h2 className="text-xs font-medium mb-1">
                Almacen: Almacen #01
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Existencia: Almacen
              </h2> */}

              {purchase?.debitNote?.code ? (
                <div>
                <h2 className="text-xs font-medium mb-1">
                  {/* Almacén: {sale?.warehouse?.name} */}
                  Fecha:{' '}
                  {purchase?.debitNote?.date
                    ? transformDate(purchase?.debitNote?.date)
                    : 'N/A'}
                </h2>

                <h2 className="text-xs font-medium mb-1">
                  Total: {formatPipe(purchase?.cost)}
                </h2>

                <h2 className="text-xs font-medium mb-1">
                  Nmo de crédito: {purchase?.debitNote?.code}
                </h2>
              </div>
              ) : (
                <h2 className="text-xs font-medium mb-1">
                  No hay ninguna devolución
                </h2>
              )}

            </div>
            <div
              className="dark:bg-black bg-primary-1500 col-span-6 row-span-3 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2 className="text-xs font-medium mb-1" style={{ color: '#006AEA' }}>
                Factura
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Fecha: {purchase?.bill?.date ? transformDate(purchase?.bill?.date) : 'N/A'}
              </h2>

              <h2 className="text-xs font-medium mb-1">
              Nro. Control: {purchase?.bill?.control || 'N/A'}
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Código de Factura: {purchase?.bill?.code || 'N/A'}
              </h2>

            </div>

            {hasWithholdingData(purchase?.withholding) && (
              <div
                className="dark:bg-black bg-primary-1500 col-span-6 row-span-4 p-3"
                style={{
                  borderRadius: 6,
                  boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
                }}
              >
                <h2 className="text-xs font-medium mb-1" style={{ color: '#006AEA' }}>
                  Retención IVA
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Nro. Comprobante: {purchase?.withholding?.voucher_number || 'N/A'}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Base Imponible: {formatPipe(purchase?.withholding?.tax_base)}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Exento: {formatPipe(purchase?.withholding?.excempt)}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Total IVA: {formatPipe(purchase?.withholding?.tax_total)}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Porcentaje Retención: {purchase?.withholding?.withholding_percentage}%
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Monto Retenido: {formatPipe(purchase?.withholding?.amount_withheld)}
                </h2>
              </div>
            )}

            {hasWithholdingData(purchase?.islrWithholding) && (
              <div
                className="dark:bg-black bg-primary-1500 col-span-6 row-span-4 p-3"
                style={{
                  borderRadius: 6,
                  boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
                }}
              >
                <h2 className="text-xs font-medium mb-1" style={{ color: '#006AEA' }}>
                  Retención ISLR
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Nro. Comprobante: {purchase?.islrWithholding?.voucher_number || 'N/A'}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Base Imponible: {formatPipe(purchase?.islrWithholding?.tax_base)}
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Porcentaje Retención: {purchase?.islrWithholding?.withholding_percentage}%
                </h2>
                <h2 className="text-xs font-medium mb-1">
                  Monto Retenido: {formatPipe(purchase?.islrWithholding?.amount_withheld)}
                </h2>
              </div>
            )}

            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-12 row-span-5 p-3"
              style={{ height: '100%', overflow: 'auto',
              borderRadius: 6,
              boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : ''}}
            >
               <h2 className="text-xs font-medium mb-3" style={{ color: '#006AEA' }}>
                Pagos realizados
              </h2>
              <Table
                columns={paymentsColumns}
                data={purchase?.payments}
                showPagination={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

interface IWatchPurchase {
  purchase: any
}

export default WatchPurchase
